import SliderContainer from './slider-container'
import Section from './section'
import { memo } from 'react'


const Wrapper = ({ items, url }) => (
   <div className='filters'>
      <SliderContainer url={url} />
      {items.map((item) => <Section key={item.id} {...item} />)}
   </div>
)

export default memo(Wrapper)
